// assets
import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';

// type
import { NavItemType } from 'types/menu';
import { ApartmentOutlined, BankOutlined, CreditCardOutlined, CustomerServiceOutlined, FolderOpenOutlined, LoginOutlined, MailOutlined, ProjectOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { TemplateIcon } from 'utils/TaskManagementIcon/taskmanagemeneticon';
import { inspectionTempalteMenuIcon, ModernNotaryIcon } from 'utils/icons';

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType = {
  id: 'group-applications',
  title: 'settings',
  icon: AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: 'notary',
      title: 'Notaries',
      subtitle: 'Manage notary information for PCA forms.',
      type: 'item',
      url: '/settings/notaries',
      icon: ModernNotaryIcon,
      featureID: 60
    },
    {
      id: 'Contractor-Company-Profile',
      title: 'Company Profile',
      subtitle: 'Manage your company profile and contact details.',
      type: 'item',
      url: '/contractors/companyprofile',
      icon: ProjectOutlined,
      featureID: 33
    },
    {
      id: 'inspection-email-templates',
      title: 'Inspection Email Templates',
      subtitle: 'Manage common inspection email templates for Notify and Result',
      type: 'collapse',
      icon: inspectionTempalteMenuIcon,
      featureID: 56,
      children: [
        {
          id: 'inspection-email-template-notify',
          title: 'Notify City',
          subtitle: 'Configure the common email template for inspection notifications.',
          type: 'item',
          url: '/settings/inspection-email-templates/notify',
          breadcrumbs: false,
          featureID: 56
        },
        {
          id: 'inspection-email-template-result',
          title: 'Result City',
          subtitle: 'Configure the common email template for inspection results.',
          type: 'item',
          url: '/settings/inspection-email-templates/result',
          breadcrumbs: false,
          featureID: 56
        }
      ]
    },
    {
      id: 'tenants',
      title: 'Tenants',
      subtitle: 'Manage Tenants and Private Provider Firms',
      type: 'item',
      url: '/apps/tenants',
      icon: BankOutlined,
      featureID: 12,
    },
    {
      id: 'tenants-new',
      title: 'New Tenant',
      subtitle: 'Setup a new tenant organization and primary administrator',
      type: 'item',
      url: '/apps/tenants/new',
      visible: false,
      breadcrumbs: false,
      featureID: 12
    },
    {
      id: 'tenants-edit',
      title: 'Edit Tenant',
      subtitle: 'Update tenant organization details and administrator settings',
      type: 'item',
      url: '/apps/tenants/edit/:tenantID',
      visible: false,
      breadcrumbs: false,
      featureID: 12
    },
    {
      id: 'tenants-view',
      title: 'View Tenant',
      subtitle: 'Review tenant information and configuration',
      type: 'item',
      url: '/apps/tenants/view/:tenantID',
      visible: false,
      breadcrumbs: false,
      featureID: 12
    },

    {
      id: 'proposaltemplates',
      title: 'Proposal Templates',
      subtitle: 'Manage proposal templates',
      type: 'item',
      url: '/apps/proposaltemplates',
      icon: CreditCardOutlined,
      featureID: 21
    },
    {
      id: 'proposal-template-new',
      title: 'New Proposal Template',
      subtitle: 'Manage New Proposal Template',
      type: 'item',
      breadcrumbs: true,
      visible: false,
      url: '/apps/proposaltemplates/new',
      icon: ProjectOutlined,
      featureID: 21
    },
    {
      id: 'proposal-template-edit',
      title: 'Edit Proposal Template',
      subtitle: 'Manage Edit Proposal Template',
      type: 'item',
      breadcrumbs: true,
      visible: false,
      url: '/apps/proposaltemplates/edit/:proposalTemplateID',
      icon: ProjectOutlined,
      featureID: 21
    },
    {
      id: 'master-agreement-templates',
      title: 'Master Agreement Templates',
      subtitle: 'Manage master agreement templates',
      type: 'item',
      url: '/settings/masterAgreementTemplates',
      icon: CreditCardOutlined,
      featureID: 22
    },
    {
      id: 'master-agreement-templates',
      title: 'Master Agreement Templates',
      subtitle: 'Manage master agreement templates',
      type: 'item',
      url: '/settings/masterAgreementTemplates/edit/:masterAgreementTemplateID',
      icon: CreditCardOutlined,
      featureID: 22,
      breadcrumbs: true,
      visible: false,
    },
    // {
    //   id: 'default-file-categories',
    //   title: 'Default File Categories',
    //   subtitle: 'Manage default file categories',
    //   type: 'item',
    //   url: '/settings/defaultFileCategories/project',
    //   icon: ApartmentOutlined,
    //   featureID: 25,
    //   breadcrumbs: true,
    //   visible: true,
    // },
    {
      id: 'task-templates',
      title: 'Task Templates',
      subtitle: 'View and manage Contractor Subscription ',
      type: 'item',
      url: '/settings/taskTemplates',
      icon: TemplateIcon,
      featureID: 48
    },
    {
      id: 'task-templates',
      title: 'Task Templates',
      subtitle: 'View and manage Contractor Subscription ',
      type: 'item',
      url: '/settings/taskTemplates/:mode/:taskTemplateID',
      icon: TemplateIcon,
      featureID: 48,
      breadcrumbs: false,
      visible: false,
    },
    ////Defaul Folders

    {
      id: 'default-folder',
      title: 'Default Folders',
      subtitle: 'Manage default folders',
      type: 'item',
      url: '/settings/defaultfolder/project',
      icon: FolderOpenOutlined,
      featureID: 25,
      breadcrumbs: true,
      visible: true,
    },
    {
      id: 'default-folder',
      title: 'Default Folders',
      subtitle: 'Manage default folders',
      type: 'item',
      url: '/settings/defaultfolder/municipality',
      icon: FolderOpenOutlined,
      featureID: 25,
      breadcrumbs: true,
      visible: false,
    },


    // {
    //   id: 'default-file-categories',
    //   title: 'Default File Categories',
    //   subtitle: 'Manage default file categories',
    //   type: 'item',
    //   url: '/settings/defaultFileCategories/municipality',
    //   icon: ApartmentOutlined,
    //   featureID: 25,
    //   breadcrumbs: true,
    //   visible: false,
    // },

    {
      id: 'services',
      title: 'Services',
      subtitle: 'Manage default, local, and overridden services',
      type: 'item',
      url: '/settings/service',
      icon: CustomerServiceOutlined,
      featureID: 17
    },

    {
      id: 'Permit Type Selection',
      title: 'Permit Type Selection for Plan Review and Inspections in Users',
      subtitle: 'Permit Type Selection for Plan Review and Inspections in Users',
      type: 'item',
      url: '/apps/users/permittypeConfiguration',
      icon: UserOutlined,
      featureID: 35,
      visible: false,
      breadcrumbs: false
    },

    {
      id: 'states',
      title: 'states',
      subtitle: 'View and manage states',
      type: 'item',
      url: '/apps/states',
      icon: EnvironmentOutlined,
      featureID: 4
    },
    {
      id: 'counties',
      title: 'Counties',
      subtitle: 'Maintain city details mapped to states and countries',
      type: 'item',
      url: '/apps/counties',
      icon: BankOutlined,
      featureID: 7
    },

    {
      id: 'cities',
      title: 'Cities',
      subtitle: 'Maintain city details mapped to states and countries',
      type: 'item',
      url: '/apps/cities',
      icon: BankOutlined,
      featureID: 3
    },
    {
      id: 'masteraddress',
      title: 'Master Address',
      subtitle: 'Manage and filter your statewide address database with ease',
      type: 'item',
      url: '/apps/masteraddress',
      icon: EnvironmentOutlined,
      featureID: 46
    },
    {
      id: 'municipalities',
      title: 'Municipalities',
      subtitle: 'Manage and track regional registrations across the country',
      type: 'item',
      url: '/apps/municipalities',
      icon: BankOutlined,
      featureID: 10
    },
    {
      id: 'municipalities',
      title: 'Municipalities',
      subtitle: 'Manage and track regional registrations across the country',
      type: 'item',
      url: '/apps/municipalities/:municipalityID',
      visible: false,
      breadcrumbs: false,
      featureID: 10
    },
    {
      id: 'municipality',
      title: 'Municipality',
      subtitle: 'Review municipality information and configuration',
      type: 'item',
      url: '/apps/cities/municipality/:municipalityID',
      visible: false,
      breadcrumbs: false,
      featureID: 10
    },
    {
      id: 'municipality',
      title: 'Municipality',
      subtitle: 'Review municipality information and configuration',
      type: 'item',
      url: '/apps/counties/municipality/:municipalityID',
      visible: false,
      breadcrumbs: false,
      featureID: 10
    },
    {
      id: 'user-profile',
      title: 'user-profile',
      subtitle: 'Manage your personal information and account settings',
      type: 'item',
      url: '/apps/profiles/user',
      visible: false,
      breadcrumbs: false,
      featureID: 1
    },
    {
      id: 'user-signatures',
      title: 'My Signatures',
      subtitle: 'Manage user license, signature and seal.',
      type: 'item',
      url: '/apps/profiles/signatures',
      visible: false,
      breadcrumbs: false,
      featureID: 1
    },
    {
      id: 'users',
      title: 'Users',
      subtitle: 'Manage system users and their permissions',
      type: 'item',
      url: '/apps/users',
      icon: UserOutlined,
      featureID: 1
    },

    {
      id: 'roles',
      title: 'Roles',
      subtitle: 'Manage user roles and access permissions',
      type: 'item',
      url: '/apps/roles',
      icon: UsergroupAddOutlined,
      featureID: 2,
      breadcrumbs: false,
      children: [
        {
          id: 'assignPermissions',
          title: 'Role Permissions',
          subtitle: 'Configure permissions for the selected role',
          type: 'item',
          url: '/apps/roles/permissions/:userRoleID',
          icon: UsergroupAddOutlined,
          breadcrumbs: false,
          visible: false
        }
      ]
    },


    {
      id: 'Email-logs',
      title: 'Email Logs',
      subtitle: 'Monitor user login activity and access history',
      type: 'item',
      url: '/apps/emaillogs',
      icon: MailOutlined,
      featureID: 6
    },

    {
      id: 'login-logs',
      title: 'Login Logs',
      subtitle: 'Monitor user login activity and access history',
      type: 'item',
      url: '/apps/loginLogs',
      icon: LoginOutlined,
      featureID: 5
    },



  ]
};

export default applications;
